import {fromEvent} from 'rxjs';
import {map, filter} from 'rxjs/operators';

import * as MainNavigationActions from 'web-app/react/main-navigation/actions';
import {iOSKeyboardFix} from 'web-app/util/layout';

const getEventObservable = (eventName: string) =>
    fromEvent(document, eventName).pipe(
        map((event: any) => {
            return event.target;
        }),
        filter(target => {
            return target.matches && target.matches('form, textarea, input:not([type="checkbox"]), select');
        }),
    );

const setupMenuHide = () => {
    if ('addEventListener' in document) {
        getEventObservable('focusin').subscribe(() => {
            MainNavigationActions.focusMode.dispatch(true);
        });

        getEventObservable('focusout').subscribe(() => {
            MainNavigationActions.focusMode.dispatch(false);
            iOSKeyboardFix();
        });

        // Sometimes e.g. on login, the input element will be unmounted before it can emit the focusout event which
        // means we'll manually have to dispatch the focusMode false
        getEventObservable('submit').subscribe(() => {
            MainNavigationActions.focusMode.dispatch(false);
        });
    }
};

export default setupMenuHide;
